import(/* webpackMode: "eager" */ "/vercel/path0/app/(app)/advisor/page.tsx");
